/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import { connect } from 'react-redux';
import classnames from 'classnames';
import {setProducts, initQuote, setCompany} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { Tooltip } from 'reactstrap';
import Lightbox from 'react-image-lightbox';

import { API_URL, downloadFile } from"../../network";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";


import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Moment from 'react-moment';

function Index(props) {
  const [tableData, setTableData] = useState([]);
  const [showTableData, setShowTableData] = useState([]);
  
  const [activeTab, setActiveTab] = useState('1');  
  const [loading, setLoading] = useState(false);
  const [tooltipStatus, setTooltipStatus] = useState(false);
  const [tooltipValid, setTooltipValid] = useState(false);
  const [openLogoImage, setOpenLogoImage] = useState(false)
  const [modalImage, setModalImage] = useState(false)
  const [search, setSearch] = React.useState('');
  const [sortConfig, setSortConfig] = React.useState({});
  
  const [logOpen, setLogOpen] = useState(false)
  const [logData, setLogData] = useState("")
  
  const main = useRef();
  const [modal, setModal] = useState(false);

  const toggle=(tab)=> {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  
  const toggleProductImage = () => {
    console.log("toggle");
    setOpenLogoImage(!openLogoImage);
  }
  const viewLog = (id)=>{
    axios.get(`/quotes/getlog/${id}`).then(res => {
      setLogOpen(true)
      setLogData(res.data)
    })    
  }

  const toggleTooltipStatus = () => setTooltipStatus(!tooltipStatus);
  const toggleTooltipValid = () => setTooltipValid(!tooltipValid);

  const showLogo = (item)=>{    
    axios.get(`/quotes/logo/${item['id']}`).then(res => {
      setOpenLogoImage(true)
        setModalImage('data:image/png;base64, '+res.data)
    })    
  }

  const fetchData = ()=>{
    setLoading(true)
    const queryParams = new URLSearchParams(window.location.search);
    const userid = queryParams.get('userid');
    const url =API_URL+ 'quotes/index'; 
    axios.get('quotes/index', { //'quotes/index'
      params: {
        userid: userid
      }
    }).then(res => {
      console.log('res.data',res.data)      
      setLoading(false)
      if(res.data.status == "success")
        setTableData(res.data.data);
        setShowTableData(res.data.data)
    }).catch(error => {
      setLoading(false); // stop loading even if there’s an error
      console.error('Error fetching quotes:', error);

      // Optionally show a message to the user:
      alert('Failed to fetch data. Please try again later.');
    });    
  }
  useEffect(() => {
    props.initQuote()
    props.setCompany(null)
    fetchData()
  },[]);

  useEffect(() => {    
    var showTableData = [...tableData];
    if (sortConfig !== null) {
      showTableData.sort((a, b) => {
        if(sortConfig.key == "company"){
          var companyA = (a['company']&&a['company']['company']?a['company']['company']:"")
          var companyB = (b['company']&&b['company']['company']?b['company']['company']:"")
          if (companyA < companyB) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (companyA > companyB) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        else if(sortConfig.key == "name"){
          var companyA = (a['label']?a['label']:"")+(a['revision']?" - R"+a['revision']:"")
          var companyB = (b['label']?b['label']:"")+(b['revision']?" - R"+b['revision']:"")
          if (companyA < companyB) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (companyA > companyB) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        else{
          var valA = a[sortConfig.key]?a[sortConfig.key]:""
          var valB = b[sortConfig.key]?b[sortConfig.key]:""
          if (valA < valB) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (valA > valB) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
      });
    }
    if(search){
      showTableData = showTableData.filter((item) =>
        (item.label && item.label.toLowerCase().includes(search.toLowerCase()))||
        (item.status && item.status.toLowerCase().includes(search.toLowerCase()))||
        (item.id && String(item.id).includes(search))||
        (item.company && item.company.company && item.company.company.toLowerCase().includes(search.toLowerCase()))
      )
    }
    setShowTableData(showTableData)
  },[sortConfig, search]);

  const submitSent = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('sent', value?1:0);

    axios.post(`/quotes/setsent/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        fetchData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const submitReady = (quoteId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('ready', value?1:0);

    axios.post(`/quotes/setready/${quoteId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){ 
        toast.success('You have set successfully');
        fetchData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const setArchive =async(orderId, value)=>{
    var bodyFormData = new FormData();
    bodyFormData.append('archive', value);    
    setLoading(true)
    axios.post(`/quotes/setarchive/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        fetchData()
      }
      else{
        toast.error(result.data);
      }    
      setLoading(false)
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const token = localStorage.getItem('token_bigbrand');    
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  

  const requestSort = (key) => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-4">
            <Col  md="3">     
              <FormGroup>
                <Input type="search" name="search" id="exampleSearch" placeholder="Search Quote" onChange={handleSearch}/>
              </FormGroup>
            </Col>
          </Row>
          <Row  className="mt-3 orders-tabs">
            <Col  md="12">     
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => { toggle('1'); }}
                  >
                    Quotes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => { toggle('2'); }}
                  >
                    Archive
                  </NavLink>
                </NavItem>        
              </Nav>       
              <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="">   
                    <div style={{background:'white'}}>
                      {/* <h5 className="p-3">Pending Quotes</h5> */}
                      <Card body>
                        <Table  striped  className="sorttable">
                          <thead>
                            <tr>
                              <th width="70px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('id')}
                                  className={getClassNamesFor('id')}
                                >
                                  Id
                                  {getClassNamesFor('id') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('id') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th>
                                <button
                                  type="button"
                                  onClick={() => requestSort('name')}
                                  className={getClassNamesFor('name')}
                                >
                                  Name
                                  {getClassNamesFor('name') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('name') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>                              
                              <th width="200px">Description</th>
                              <th width="200px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('company')}
                                  className={getClassNamesFor('company')}
                                >
                                  Company
                                  {getClassNamesFor('company') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('company') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="160px">
                                <div className="d-flex align-items-center">
                                  <button
                                    type="button"
                                    onClick={() => requestSort('status')}
                                    className={getClassNamesFor('status')}
                                  >
                                    Status
                                    {getClassNamesFor('status') == "ascending"&&
                                    <i class="ml-1 fa fa-arrow-down"></i>
                                    }
                                    {getClassNamesFor('status') == "descending"&&
                                    <i class="ml-1 fa fa-arrow-up"></i>
                                    }
                                  </button>
                                  <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipStatus" >i</label>
                                  <Tooltip placement="bottom" isOpen={tooltipStatus} className="text-left" target="tooltipStatus" toggle={toggleTooltipStatus}>
                                    Status<br/>
                                  </Tooltip>
                                </div>
                              </th>
                              <th width="120px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('updated_at')}
                                  className={getClassNamesFor('updated_at')}
                                >
                                  Created
                                  {getClassNamesFor('updated_at') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('updated_at') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="160px">
                                <div className="d-flex align-items-center">
                                  <button
                                    type="button"
                                    onClick={() => requestSort('valid_to')}
                                    className={getClassNamesFor('valid_to')}
                                  >
                                    Valid Until
                                    {getClassNamesFor('valid_to') == "ascending"&&
                                    <i class="ml-1 fa fa-arrow-down"></i>
                                    }
                                    {getClassNamesFor('valid_to') == "descending"&&
                                    <i class="ml-1 fa fa-arrow-up"></i>
                                    }
                                  </button>
                                  <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipValid" >i</label>
                                  <Tooltip placement="bottom" isOpen={tooltipValid} className="text-left" target="tooltipValid" toggle={toggleTooltipValid}>
                                    valid until<br/>
                                  </Tooltip>
                                </div>
                              </th>
                              <th width="80px">View</th>
                              <th width="100px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('price')}
                                  className={getClassNamesFor('price')}
                                >
                                  Total
                                  {getClassNamesFor('price') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('price') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="60px">Ready/<br/>Review</th>
                              <th width="60px">Sent</th>
                              <th width="60px" className="text-center" >Archive</th>
                              <th width="100px">History</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              showTableData.map((row, index)=>{
                                if(!row.archive)
                                return (
                                  <tr key={index}>
                                    {/* <td width="50px" className="pl-2 pr-2" scope="row">
                                      <span style={{cursor:"pointer"}} onClick={()=>{showLogo(row)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                                    </td> */}
                                    <td>
                                      #{row['id']}
                                    </td>
                                    <td>
                                      {(row['label']?row['label']:"")+(row['revision']?" - R"+row['revision']:"")}
                                    </td>
                                    <td>
                                      {(row['client_label']?row['client_label']:"")}
                                    </td>
                                    <td>
                                      {(row['company']&&row['company']['company']?row['company']['company']:"")}
                                    </td>
                                    <td className="pl-2 pr-2">
                                      {row['status']}
                                    </td>
                                    <td className="pl-2 pr-2">      
                                    {row['created_at']?                  
                                      <Moment format="DD/MM/YYYY">
                                        {row['created_at']}
                                      </Moment>
                                      :""
                                    }
                                    </td>
                                    <td className="pl-2 pr-2">
                                      {row['valid_to']?                  
                                        <Moment format="DD/MM/YYYY">
                                          {row['valid_to']}
                                        </Moment>
                                        :""
                                      }
                                    </td>
                                    <td>                        
                                      <Button size="sm"
                                        onClick={()=>role=='admin'?props.history.push(("/admin/requests/edit/")+row['id']):props.history.push(("/requests/edit/")+row['id'])}
                                        className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                                        <span className="btn-inner--text">View</span>
                                      </Button>
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                      ${row['price']?(row['price']+row['price']/10).toFixed(2):0}
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input
                                          className="custom-control-input"
                                          id={`customCheckReady${index}`}
                                          type="checkbox"
                                          checked={row['ready']}
                                          onChange={()=>submitReady(row['id'], !row['ready'])}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckReady${index}`}
                                        >
                                          <span></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input
                                          className="custom-control-input"
                                          id={`customCheckSent${index}`}
                                          type="checkbox"
                                          checked={row['sent']}
                                          onChange={()=>submitSent(row['id'], !row['sent'])}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckSent${index}`}
                                        >
                                          <span></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td className="text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input 
                                          className="custom-control-input"
                                          id={`customCheckActive${index}`} type='checkbox' onChange={()=>setArchive(row['id'], 1)}/>                                           
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckActive${index}`}
                                        >
                                          <span></span>
                                        </label> 
                                      </div>  
                                    </td>  
                                    <td className="pl-2 pr-2">
                                      <Button size="sm"
                                        onClick={()=>{viewLog(row['id'])}} outline
                                        className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                                        <span className="btn-inner--text">View</span>
                                      </Button>
                                    </td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </Table>
                      </Card>
                    </div>
                  </TabPane>
                  <TabPane tabId="2" className="">
                    <div style={{background:'white'}}>
                      {/* <h5 className="p-3">Pending Quotes</h5> */}
                      <Card body>
                        <Table  striped  className="sorttable">
                        <thead>
                            <tr>
                              <th width="50px"></th>
                              <th width="70px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('id')}
                                  className={getClassNamesFor('id')}
                                >
                                  Id
                                  {getClassNamesFor('id') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('id') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th>
                                <button
                                  type="button"
                                  onClick={() => requestSort('name')}
                                  className={getClassNamesFor('name')}
                                >
                                  Name
                                  {getClassNamesFor('name') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('name') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="200px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('company')}
                                  className={getClassNamesFor('company')}
                                >
                                  Company
                                  {getClassNamesFor('company') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('company') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="160px">
                                <div className="d-flex align-items-center">
                                  <button
                                    type="button"
                                    onClick={() => requestSort('status')}
                                    className={getClassNamesFor('status')}
                                  >
                                    Status
                                    {getClassNamesFor('status') == "ascending"&&
                                    <i class="ml-1 fa fa-arrow-down"></i>
                                    }
                                    {getClassNamesFor('status') == "descending"&&
                                    <i class="ml-1 fa fa-arrow-up"></i>
                                    }
                                  </button>
                                  <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipStatus" >i</label>
                                  <Tooltip placement="bottom" isOpen={tooltipStatus} className="text-left" target="tooltipStatus" toggle={toggleTooltipStatus}>
                                    Status<br/>
                                  </Tooltip>
                                </div>
                              </th>
                              <th width="120px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('updated_at')}
                                  className={getClassNamesFor('updated_at')}
                                >
                                  Created
                                  {getClassNamesFor('updated_at') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('updated_at') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="160px">
                                <div className="d-flex align-items-center">
                                  <button
                                    type="button"
                                    onClick={() => requestSort('valid_to')}
                                    className={getClassNamesFor('valid_to')}
                                  >
                                    Valid Until
                                    {getClassNamesFor('valid_to') == "ascending"&&
                                    <i class="ml-1 fa fa-arrow-down"></i>
                                    }
                                    {getClassNamesFor('valid_to') == "descending"&&
                                    <i class="ml-1 fa fa-arrow-up"></i>
                                    }
                                  </button>
                                  <label className="help-icon" style={{margin:"2px 0 0 11px"}} href="#" id="tooltipValid" >i</label>
                                  <Tooltip placement="bottom" isOpen={tooltipValid} className="text-left" target="tooltipValid" toggle={toggleTooltipValid}>
                                    valid until<br/>
                                  </Tooltip>
                                </div>
                              </th>
                              <th width="100px">History</th>
                              <th width="100px">
                                <button
                                  type="button"
                                  onClick={() => requestSort('price')}
                                  className={getClassNamesFor('price')}
                                >
                                  Total
                                  {getClassNamesFor('price') == "ascending"&&
                                  <i class="ml-1 fa fa-arrow-down"></i>
                                  }
                                  {getClassNamesFor('price') == "descending"&&
                                  <i class="ml-1 fa fa-arrow-up"></i>
                                  }
                                </button>
                              </th>
                              <th width="60px">Ready/<br/>Review</th>
                              <th width="60px">Sent</th>
                              <th width="60px" className="text-center" >Archive</th>
                              <th width="80px">View</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              showTableData.map((row, index)=>{
                                if(row.archive)
                                return (
                                  <tr key={index}>
                                    <td width="50px" className="pl-2 pr-2" scope="row">
                                      <span style={{cursor:"pointer"}} onClick={()=>{showLogo(row)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                                    </td>
                                    <td>
                                      #{row['id']}
                                    </td>
                                    <td>
                                      {(row['label']?row['label']:"")+(row['revision']?" - R"+row['revision']:"")}
                                    </td>
                                    <td>
                                      {(row['company']&&row['company']['company']?row['company']['company']:"")}
                                    </td>
                                    <td className="pl-2 pr-2">
                                      {row['status']}
                                    </td>
                                    <td className="pl-2 pr-2">      
                                    {row['updated_at']?                  
                                      <Moment format="DD/MM/YYYY">
                                        {row['updated_at']}
                                      </Moment>
                                      :""
                                    }
                                    </td>
                                    <td className="pl-2 pr-2">
                                      {row['valid_to']?                  
                                        <Moment format="DD/MM/YYYY">
                                          {row['valid_to']}
                                        </Moment>
                                        :""
                                      }
                                    </td>
                                    <td className="pl-2 pr-2">
                                      <Button size="sm"
                                        onClick={()=>{viewLog(row['id'])}} outline
                                        className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                                        <span className="btn-inner--text">View</span>
                                      </Button>
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                    ${row['price']?(row['price']+row['price']/10).toFixed(2):0}
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input
                                          className="custom-control-input"
                                          id={`customCheckReady${index}`}
                                          type="checkbox"
                                          checked={row['ready']}
                                          onChange={()=>submitReady(row['id'], !row['ready'])}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckReady${index}`}
                                        >
                                          <span></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td className="pl-2 pr-2 text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input
                                          className="custom-control-input"
                                          id={`customCheckSent${index}`}
                                          type="checkbox"
                                          checked={row['sent']}
                                          onChange={()=>submitSent(row['id'], !row['sent'])}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckSent${index}`}
                                        >
                                          <span></span>
                                        </label>
                                      </div>
                                    </td>
                                    <td className="text-center text-center">
                                      <div className="custom-control custom-control-alternative custom-checkbox">
                                        <input 
                                          className="custom-control-input"
                                          id={`customCheckUnactive${index}`} type='checkbox' checked onChange={()=>setArchive(row['id'], 0)}/>                                           
                                        <label
                                          className="custom-control-label"
                                          htmlFor={`customCheckUnactive${index}`}
                                        >
                                          <span></span>
                                        </label> 
                                      </div>  
                                    </td>  
                                    <td>                        
                                      <Button size="sm"
                                        onClick={()=>role=='admin'?props.history.push(("/admin/requests/edit/")+row['id']):props.history.push(("/requests/edit/")+row['id'])}
                                        className="btn-icon btn-3 rounded-0 border-3" color="primary" type="button">
                                        <span className="btn-inner--text">View</span>
                                      </Button>
                                    </td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </Table>
                      </Card>
                    </div>
                  </TabPane>
              </TabContent> 
            </Col>
          </Row>
        </Container>
        {openLogoImage && (
          <Lightbox
            mainSrc={modalImage?modalImage:require("assets/img/theme/product-placeholder.jpg")}
            
            onCloseRequest={() => toggleProductImage()}
          />
        )} 
        
        <Modal isOpen={logOpen} toggle={()=>setLogOpen(false)} >
          <ModalHeader toggle={()=>setLogOpen(false)}>History</ModalHeader>
          <ModalBody>
              <FormGroup>
                <Input style={{whitespace: 'pre-line', maxHeight:150, overflowY:'auto'}} disabled type="textarea" rows="8" value={logData?logData:""}/> 
              </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" size="sm" onClick={()=>setLogOpen(false)}>Close</Button>
          </ModalFooter>
        </Modal>
        <LoadingOverlay
          active={loading}
          styles={{
              overlay: (base) => ({
              ...base,
              fontSize:'18px',
              color: 'rgb(5, 37, 51)',
              background: 'rgb(60 60 60 / 48%)',
              position:'fixed',
              zIndex:1000000000
              })
          }}
          spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
          // spinner
          // text='Loading ...'
          >
        </LoadingOverlay> 
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    initQuote:()=>dispatch(initQuote()),
    setCompany:(data)=>dispatch(setCompany(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
